export default __webpack_public_path__ + "static/media/meal.9ad8c701.svg";